import StoryCard from "./cards/story-card.marko";
import LlFavoriteHeart from "./ll-favorite-heart.marko";

<div
  id="ll-grammar-context-grid"
  class="card-grid card-grid--3 ll-grammar-context-grid"
  data-peer-word-scale="level"
  data-words-label=(input.wordsLabel || "")
  data-vocabs-stripe-label=(input.vocabsStripeLabel || "")
  data-stripe-beyond-prefix=(input.stripeBeyondLevelPrefix || "")
>
  <for|card| of=(input.cards || [])>
    <if=(card.kind === "scene")>
      <div
        class="card adventure-scene-card ll-card-shell"
        data-scene-card
        data-scene-id=(card.scene.contentId || "")
        data-content-id=(card.scene.contentId || "")
        data-stats=(card.scene.stats ? JSON.stringify(card.scene.stats) : null)
        data-card-level=(card.scene.level || '').toLowerCase()
      >
        <a
          href=(card.scene.href || "#")
          class="card__link"
          style="text-decoration:none"
        >
          <div class="card__image-wrap">
            <if=card.scene.image>
              <img
                src=card.scene.image
                alt=(card.scene.targetTitle || "")
                class="card__image"
                width="840"
                height="360"
                loading="lazy"
                decoding="async"
                onError="this.style.display='none';var f=this.nextElementSibling;if(f&&f.classList&&f.classList.contains('card__image-placeholder'))f.removeAttribute('hidden')"
              >
              <div class="card__image-placeholder" hidden>📖</div>
            </if>
            <else>
              <div class="card__image-placeholder">📖</div>
            </else>
          </div>
          <div class="card__body">
            <div class="card__meta card__meta--story">
              <div class="ll-card-level-stripe-host" data-level-stripe tabindex="-1" aria-hidden="true"></div>
            </div>
            <if=card.scene.learnerTitle>
              <p class="title-aid">${card.scene.learnerTitle}</p>
            </if>
            <h3 class="card__title">
              <span data-ll-card-title-slot>${card.scene.targetTitle}</span>
            </h3>
            <p class="card__teaser"><span data-ll-card-teaser-slot>${card.scene.description || ""}</span></p>
            <div class="ll-card-stripe ll-card-stripe--bottom" data-stripe-bottom aria-hidden="true"></div>
          </div>
        </a>
        <LlFavoriteHeart contentId=(card.scene.contentId || "")/>
      </div>
    </if>
    <else-if=card.item>
      <StoryCard
        item=card.item
        basePath=input.storiesBasePath
        contentKindBadge=(input.kindStoryLabel || "")
      />
    </else-if>
  </for>
</div>
